import Service, { inject as service } from "@ember/service"
import type { DocumentStore } from "@supergrain/silo"

import type { TypeToModel } from "@shared/models/type-to-model"
import type InternalSupergrainStore from "./internal-supergrain-store"

/**
 * The public React-facing store. React components (via the document-store
 * provider and `useDocument`) talk to this facade. It is a thin wrapper over the
 * internal Supergrain store and has no connection to the Ember side; the two
 * internal stores stay in sync through the document replicator and patch
 * coordinator.
 */
export default class ReactStore extends Service {
  @service("internal-supergrain-store") declare internalSupergrainStore: InternalSupergrainStore

  get documentStore(): DocumentStore<TypeToModel> {
    return this.internalSupergrainStore.documentStore
  }
}

declare module "@ember/service" {
  interface Registry {
    "react-store": ReactStore
  }
}
